import './App.css';
import Login from '../Login/Login';
import React, { Suspense, useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme'
import { AppToastContainer } from '../../toast'

const Main = React.lazy(() => import('../Main/Main'));

const THEME_MODE_STORAGE_KEY = 'theme-mode';

function setToken(userToken) {
    localStorage.setItem('token', userToken);
    window.location.reload()
}

function getToken() {
    const token = localStorage.getItem('token');
    return token !== 'undefined' ? token : false
}

export default function App() {
    const token = getToken();

    const [mode, setMode] = useState(() => {
        try {
            return localStorage.getItem(THEME_MODE_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
        } catch (e) {
            return 'light';
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
        } catch (e) {
            // ignore storage errors (e.g. private browsing)
        }
        document.documentElement.setAttribute('data-theme', mode);
    }, [mode]);

    const toggleMode = () => setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

    const theme = getTheme(mode);

    if (token) {
        return (
            <ThemeProvider theme={theme}>
                <Suspense fallback={<div className="app-loading" aria-label="Loading application" />}>
                    <Main mode={mode} toggleMode={toggleMode} />
                </Suspense>
                <AppToastContainer mode={mode} />
            </ThemeProvider>
        )
    }
    return (
        <ThemeProvider theme={theme}>
            <Login setToken={setToken}/>
            <AppToastContainer mode={mode} />
        </ThemeProvider>
    )
}
